
export const UNLOCK_PLAYER = 'UNLOCK_PLAYER';

export const unlockPlayer = () => ({
    type: UNLOCK_PLAYER,
});
